import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[numericKeyboard]'
})
export class NumericKeyboardDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const input = this.el.nativeElement.querySelector('input');
    if (input) {
      input.setAttribute('inputmode', 'numeric');
      input.setAttribute('pattern', '[0-9]*');
      input.setAttribute('type', 'text');
    }
  }
}
